























































import Vue from 'vue'
import { debounce } from 'debounce'
import Analytics from '@/services/Analytics'
import templateMixin from '@/mixins/template-mixin'
import Template from '@/types/Template.interface'
export default Vue.extend({
    name: 'TemplatesMenu',
    mixins: [templateMixin],
    props: {
        icon: {
            type: Boolean,
            default: true
        },
        isInvoice: {
            type: Boolean,
            default: false
        },
        small: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false,
            required: false
        }
    },
    data() {
        return {
            menu: false,
            open: false,
            //  Determines if we had searched or not
            searched: false,
            //  The list of templates we got from the search
            searchResults: null,
            //  Our container for our search text
            searchtext: ''
        }
    },
    computed: {
        items(): Template[] {
            //  If we searched, display those
            if (this.searched) return this.searchResults
            //  Else, display our templates
            else return this.templates
        },
        search: {
            get(): string {
                return this.searchtext
            },
            set: debounce(function (val: string): void {
                //  Set the searchtext state
                this.searchtext = val
                this.templatesSearch()
            }, 750)
        },
        templates(): Template[] {
            //  If no templates just return an empty array
            if (!this.$store.getters.messageTemplates) return []

            //  If this is invoice, then return all templates
            if (this.isInvoice) return this.$store.getters.messageTemplates
            else return this.$store.getters.messageTemplatesFiltered
        }
    },
    methods: {
        onAddTemplateClicked(): void {
            //  Pop the templates form
            this.popNewTemplate()
        },
        onTemplateSelected(template: Template): void {
            // Path that the MessageComposeBox is on
            const path = this.$route.path

            // Depending on where we are within the app we want to specify where the messagetemplate was selected from
            // Although they all come from MessageCompose we have a MessageCompose in inbox and broadcasts so we want to distinguish that
            if (path.includes('broadcast')) {
                Analytics.track('BroadcastTemplateSelected', { template_id: template.id })
            } else if (path.includes('inbox')) {
                Analytics.track('InboxTemplateSelected', { template_id: template.id })
            } else {
                //  Report action to analytics
                Analytics.track('MessageTemplateSelected', { template_id: template.id })
            }

            //  Close the selector
            this.open = false

            //  Emit selection to parent
            this.$emit('onTemplateSelected', template)
        },
        templatesSearch(): void {
            //  If searchtext is null, then reset
            if (!this.searchtext) {
                //  Set to false so we display regular list
                this.searched = false
                //  Set to null to remove search results
                return (this.searchResults = null)
            }

            //  Else grab our search text
            const text = this.searchtext

            //  Grab our templates
            const templates = this.templates

            //  Search on them
            const results = templates.search(text, ['message_body', 'template_name'])

            //  set our search results
            this.searchResults = results

            //  Turn this on so we display the list
            this.searched = true
        }
    }
})
